module.exports = __webpack_public_path__ + "img/trieste_hero_card.ece87768.png";